<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section class="box">

        <div class="header">
        	<div class="header_title">正品认证查询中心</div>
        	<div class="header_main">
        		<div class="header_main_title">防伪查询：</div>
        		<div class="header_main_from">
        			<input class="header_main_input" @keyup.enter="CodeVerify" v-model="vcode" placeholder="请输入防伪码" />
        			<a class="header_main_btn" @click="CodeVerify">查询</a>
        		</div>
        	</div>
        </div>

        <div class="search_result_box">
        	<div><a class="title_box">防伪查询结果</a></div>
        	<div class="search_txt" v-text="hintTxt"></div>
        </div>
        <div class="default_box" v-if="datas.focus_pics_is_show == 1">
          <div class="swiper-container banner">
            <div class="swiper-wrapper">
              <template v-if="datas.focus">
                <div v-for="(item,index) in datas.focus" v-bind:key="index" class="swiper-slide"><img style="width:100%" :src="item.img"></div>
              </template>
              <div v-else class="swiper-slide"><img style="width:100%" src="../../static/images/Normal04/banner02.png"></div>
            </div>
          </div>
        </div>

        <div v-if="datas.business && datas.business_is_show == 1">
          <div class="introduce_box">
          	<div><a class="title_box">公司产品信息</a></div>
          	<div class="introduce" v-html="datas.business.intro"></div>
          </div>

          <div class="fooder">
          	<ul>
          		<li class="fooder_row">
          			<p class="title_box paddingBox">公司名称</p>
          			<p v-text="datas.business.name"></p>
          		</li>
          		<li class="fooder_row" v-if="datas.business.customize_data" v-for="val in datas.business.customize_data">
                <p class="title_box paddingBox" v-text="val.key"></p>
                <p v-text="val.value"></p>
          		</li>
          		<li class="fooder_row">
          			<p class="title_box paddingBox">热线电话</p>
          			<p v-text="datas.business.linkphone"></p>
          		</li>
          	</ul>
          </div>
        </div>

      </section>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'AntiFake05',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  mixins: [mixin],
  data () {
    return {
      code:null,
      datas:null,
      msg:null,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      hintTxt:'',
      isShow:false,
      vcode:'',
      queryContent: null
    }
  },
  created () {
    document.querySelector('body').setAttribute('style', 'background-color:#FFF');
    this.init();
  },
  updated () {
    new Swiper('.banner',{
      autoplay : {
        delay:5000
      },
      autoHeight: true, //高度随内容变化
    })
  },
  methods:{
    async init(){
      //判断是演示还是真实码标
      if (this.$route.query.type == "demo") {
        const pid = this.$route.query.pid; //产品ID
        const rid = this.$route.query.rid; //企业ID
        this.GetDemoDatas(pid, rid);  //获取演示模板信息
      } else {
        await this.GetDatas();  //获取码标信息

        if(this.datas.business&&this.datas.business.intro){
          this.datas.business.intro = this.datas.business.intro.replaceAll('\n','</br>')
        }
        if(this.datas.verify){
          this.vcode = this.datas.verify;
          this.CodeVerify();
        }
      }
    },
    CodeVerify () {
      axios.get(this.GetServerUrl(1)+"queryVerify/"+this.code+"/"+this.vcode)
      .then( (response)=>{
        var json = response.data;
        this.queryContent = response.data.meta;
        let msg = `您查询的防伪码是${this.vcode}是${this.datas.business.name}的正品,您是第${this.datas.scan_count}次查询,请放心使用。`;
        if(json.code == 200){
          if(this.datas.many_antifake_msg){
            msg = this.datas.many_antifake_msg;
          }
          if(this.datas.first_antifake_msg){
            msg = this.datas.first_antifake_msg;
          }else{
            msg = `您查询的防伪码是${this.vcode}是${this.datas.business.name}的正品,您是第${json.meta.query_count}次查询,请放心使用。`
          }
        }
        this.hintTxt = msg;
      }).catch( (error)=>{
        this.hintTxt = `您查询的防伪码是${this.vcode}是${this.datas.business.name}的正品,您是第${this.datas.scan_count}次查询,请放心使用。`
      })
    }
  }
}
</script>

<style scoped>
* {
	padding: 0px;
	margin: 0px;
	list-style: none;
	font-style: normal;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}
.box{
  font-size: 16px !important;
	font-family: Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;
}
input,select {
	border: 0;
	outline:none;
	border-radius: 0;
	appearance:button;
	-moz-appearance:button; /* Firefox */
	-webkit-appearance:button; /* Safari 和 Chrome */
}
.header{
	padding:0 20px;
	overflow: hidden;
	background-color: #092162;
}
.header_title{
	text-align: center;
	font-weight: 500;
	color:#FFF;
	margin:30px 0;
	font-size:20px;
}
.header_main{
	color:#FFF;
	margin-bottom:20px;
}
.header_main_title{
	margin-bottom: 5px;
}
.header_main_from{
	position: relative;
}
.header_main_input{
	height: 30px;
	border-radius: 4px 0 0 4px;
	padding:0 10px;
	font-size: 13px;
	color:#444;
	width: calc(100% - 100px);
}
.header_main_btn{
	width: 80px;
	display: table;
	text-align: center;
	position: absolute;
	right: 0;top:0;
	line-height: 30px;
	font-size:14px;
	color:#fefefe;
	border-radius: 0 4px 4px 0;
	background-color: #225394;
}

.search_result_box{
	padding:15px;
	padding-bottom: 10px;
}
.title_box{
	display: table;
	border-radius: 50px;
	color: #FFF;
	padding:1px 5px;
	background-color: #225394;
}
.search_txt{
	color:#ec702d;
	text-indent:2em;
	margin-top:5px;
}

.banner img{
	display: block;
	width: 100%;
}

.fooder{
	padding:15px 20px;
	font-size: 14px;
}
.paddingBox{
	padding:2px 0;
}
.fooder_row{
	margin-bottom:10px;
	overflow: hidden;
}
.fooder_row p{
	float: left;
}
.fooder_row p:first-child{
	width: 75px;
	text-align: center;
}
.fooder_row p:last-child{
	margin-left: 5px;
	line-height: 24px;
	width: calc(100% - 80px);
}
.introduce_box{
	margin-top: 5px;
	padding:0 15px;
}
.introduce{
	margin-top: 5px;
	line-height: 20px;
	font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/AntiFake05.vue